export const disabledColor = "#D3D3D3";
export const teal = "#82d8d8";
